import React from "react";
import "./Form.css";
import { Helmet } from "react-helmet";
const Form = () => {
  return (
    <>
      <Helmet>
        <script
          type="text/javascript"
          id="jsFastForms"
          src="https://sfapi.formstack.io/FormEngine/Scripts/Main.js?d=RUZTrbciR-liPoiMn4MQJF8IYi0f7bwL9KtFGyEBjrKpGRxSNf77UjCXaAb_1IRD"
        ></script>
      </Helmet>
      <div className="d-flex justify-content-center">
      <div id="dvFastForms"></div>
      </div>
      <div className="richtext-section-container">
        <p>
          James Wellbeloved is a division of Direct2Pet Europe B.V.&nbsp;
          <br />
          <strong>Registered Office:&nbsp;</strong> Direct2Pet Europe B.V
          Taylorweg 5, 5466AE Veghel, Netherlands.{" "}
          <strong>Registration number:&nbsp;</strong>819782610.
        </p>
      </div>
    </>
  );
};

export default Form;
